import React from "react";
import { UseCases } from "@planzone/core";
import { Props } from "./types";
import { usePermissions, useRoles } from "./utils";

function Safeguard<UC extends UseCases[]>(props: Props<UC>) {
  const permissions = usePermissions(props.useCases, props.context);

  return <React.Fragment>{props.children(permissions)}</React.Fragment>;
}

export { Safeguard, usePermissions, useRoles };
